// extracted by mini-css-extract-plugin
module.exports = {"textStyles":"stat-label_textStyles__5uIBg","description":"stat-label_description__STwI6"};